(function () {
  'use strict';

  /* @ngdoc object
   * @name mlp-charity
   * @description
   *
   */
  angular
    .module('mlp-charity', [
      'ng-drag-scroll'
    ]);
}());
